import { render, staticRenderFns } from "./UserInputSelect.vue?vue&type=template&id=96189b68&"
import script from "./UserInputSelect.vue?vue&type=script&lang=js&"
export * from "./UserInputSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserInputSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VChip,VCombobox})
